import querystring from "query-string";
import axiosInstance, { errorHandler } from "./api";

const TRANSACTIONS_URL = "/tps/api/transfer-management/iroha-transactions";

const getTransactions = axios => direction => (
  page,
  size,
  filter = "",
  sort = "",
  type = "ALL",
) =>
  axios
    .get(
      `${TRANSACTIONS_URL}/${direction}?${querystring.stringify({
        page,
        size,
        filter,
        sort,
        type,
      })}`,
    )
    .then(({ data, headers }) => ({
      data,
      total: Number(headers["x-total-count"]),
    }))
    .catch(errorHandler);

// TransferManagementResource.getIncomingIrohaTransactions
const getIncomingTransactions = axios => getTransactions(axios)("incoming");
// TransferManagementResource.getOutgoingIrohaTransactions
const getOutgoingTransactions = axios => getTransactions(axios)("outgoing");

// TransferManagementResource.getTodayIncomingIrohaTransactions
/*
 *  Dashboad for Manager -> Incoming transactions
 */
const getTodayIncomingTransactions = axios =>
  getTransactions(axios)("incoming/today");

// TransferManagementResource.getTodayOutgoingIrohaTransactions
/*
 *  Dashboad for Manager -> outgoing transactions
 */
const getTodayOutgoingTransactions = axios =>
  getTransactions(axios)("outgoing/today");

// TransferManagementResource.getIrohaTransactionDetailsById
const getTransaction = axios => id =>
  axios
    .get(`${TRANSACTIONS_URL}/${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// TransferManagementResource.getIrohaTransactionsByAccountIdAndAssetId
const getUserTransaction = axios => (accountId, id) =>
  axios
    .get(`${TRANSACTIONS_URL}/${accountId}/${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// TransferManagementResource.getMobileTransactionsByAccountId
const getAccountTransactions = axios => (
  id,
  page,
  size,
  filter = "",
  sort = "",
  type = "ALL",
  from = "",
  to = "",
) =>
  axios
    .get(
      `${TRANSACTIONS_URL}/account-details/${id}?${querystring.stringify({
        page,
        size,
        sort,
        from,
        to,
        type,
      })}`,
    )
    .then(({ data, headers }) => ({
      data,
      total: Number(headers["x-total-count"]),
    }))
    .catch(errorHandler);

const INCOMING_TX_URL = "/tps/api/transfer-management/incoming-transactions";

// TransferManagementResource.acknowledge
const acknowledge = axios => fstTrxId => {
  return axios
    .post(`${INCOMING_TX_URL}/acknowledge`, { fstTrxId })
    .then(({ data }) => data)
    .catch(errorHandler);
};

// TransferManagementResource.refund
const refund = axios => fstTrxId => {
  return axios
    .post(`${INCOMING_TX_URL}/refund`, { fstTrxId })
    .then(({ data }) => data)
    .catch(errorHandler);
};

export default {
  getIncomingTransactions: getIncomingTransactions(axiosInstance),
  getOutgoingTransactions: getOutgoingTransactions(axiosInstance),
  getTodayIncomingTransactions: getTodayIncomingTransactions(axiosInstance),
  getTodayOutgoingTransactions: getTodayOutgoingTransactions(axiosInstance),
  getTransaction: getTransaction(axiosInstance),
  getUserTransaction: getUserTransaction(axiosInstance),
  getAccountTransactions: getAccountTransactions(axiosInstance),
  acknowledge: acknowledge(axiosInstance),
  refund: refund(axiosInstance),
};
